import { useProfileData } from './useProfileData';

export const useLoggedInStatus = () => {
  const profileData = useProfileData();
  return profileData.uuid !== undefined && profileData.uuid !== null;
};
